import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const MarkdownElement = ({ element }) => {
  const { replaceTemplates } = useOnboarding();
  const style = applyStyles(element);

  const parseMarkdown = (text) => {
    let html = replaceTemplates(text);
    html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
    html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    return html;
  };

  return (
    <div 
      className="element-markdown" 
      style={style}
      dangerouslySetInnerHTML={{ __html: parseMarkdown(element.text) }}
    />
  );
};

export default MarkdownElement;

